/* eslint no-console: 0 */
export function propStats(props: any) {
  console.log('---------------------');
  const sizes = Object.keys(props).map((key) => {
    return {
      key,
      size: JSON.stringify(props[key]).length / 1024,
    };
  });

  sizes.sort((prop, prop2) => (prop.size > prop2.size ? -1 : 1));
  sizes.forEach((size) => {
    console.log(size.key, `${size.size}kb`);
  });
  const totalSize = sizes.reduce((total, size) => total + size.size, 0);

  console.log('---------------------');
  console.log('Total size', `${totalSize}kb`);
  console.log('---------------------');
  return props;
}

const shimmer = (w: number, h: number) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#AAA" offset="20%" />
      <stop stop-color="#999" offset="50%" />
      <stop stop-color="#AAA" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#AAA" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;

const toBase64 = (str: string) =>
  typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str);

export function getBase64ShimmerUrl(width: number, height: number) {
  return `data:image/svg+xml;base64,${toBase64(shimmer(width, height))}`;
}
